import {
  IconFloatingButtonProps,
  IconFloatingButton
} from '../../../button/IconFloatingButton/IconFloatingButton';

interface AttachFileButtonProps extends Omit<Omit<IconFloatingButtonProps, 'dataId'>, 'icon'> {
  triggerFileSelector: VoidFunction;
  dataId: string;
}

export function AttachFileButton({ triggerFileSelector, dataId, ...props }: AttachFileButtonProps) {
  return (
    <IconFloatingButton
      {...props}
      className='mnr-1'
      onClick={e => {
        e.stopPropagation();
        triggerFileSelector();
      }}
      aria-label='select'
      dataId={dataId}
      icon='attach'
      size='md'
    />
  );
}
